import { useStore, cloneSw } from 'Shared/StoreProvider';
import { useActiveStyles } from 'Shared/backend/ActiveStylesContext';
import { useSite } from 'Shared/SiteProvider';
import { VenueSettingsFactory } from 'Shared/VenueSettingsFactory';
import { dbPatchField } from 'Shared/forms/BaseOperations';
import { categoryLabel } from 'Shared/backend/widgets/Styles';
import { For, createMemo } from 'solid-js';
import { css } from '@emotion/css';


export function CancelStylesUi()
{
	const sw = useStore();
	const parentSw = { ...cloneSw(sw), location: (sw.location ?? []).slice(0, -3) };

	const siteTheme = (new VenueSettingsFactory()).createSettings(useSite().key).siteTheme();

	const parentActiveStyles = useActiveStyles();

	const parentStorePos = () => {
		let pos: any = parentSw.store;
		for (const part of parentSw.location) pos = pos?.[part];
		return pos;
	};

	const cancelled = () => (parentStorePos()?.removeStyles ?? []) as {category:string,type:string}[];

	const isCancelled = (category: string, type: string) =>
		cancelled().some(r => r.category === category && r.type === type);

	/*
		Include active non-tool styles. Also include any currently-cancelled styles that are no
		longer in parentActiveStyles (which filters them out once cancelled) — without this the
		option disappears and can't be un-cancelled.
	*/
	const options = createMemo(() => {
		const active = parentActiveStyles().filter(s => !siteTheme.styles['tool']?.[s.type]);
		const orphaned = cancelled().filter(r =>
			!active.some(s => s.category === r.category && s.type === r.type)
		);
		return [...active, ...orphaned];
	});

	const toggle = async (category: string, type: string) => {
		const current = cancelled();
		const newVal = isCancelled(category, type)
			? current.filter(r => !(r.category === category && r.type === type))
			: [...current, { category, type }];
		await dbPatchField(parentSw, 'removeStyles', newVal);
	};

	const rowStyle = css({
		cursor: 'pointer',
		userSelect: 'none',
		display: 'flex',
		alignItems: 'center',
		gap: '0.4em',
		padding: '0.1em 0',
	});

	return (
		<For each={options()}>{s =>
			<div class={rowStyle} onClick={() => toggle(s.category, s.type)}>
				<span>{isCancelled(s.category, s.type) ? '☑' : '☐'}</span>
				<span>{categoryLabel(s.category)} {'>'} {s.type}</span>
			</div>
		}</For>
	);
}
